var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-section-scroll",style:(_vm.masterStyles),attrs:{"id":`${_vm.idMaster}-scroll-master`}},[_c('div',{staticClass:"container scrollbar_basic",style:(_vm.containerStyles),attrs:{"id":`${_vm.idMaster}-scroll-container`},on:{"scroll":function($event){return _vm.setShadows(
        `${_vm.idMaster}-scroll-master`,
        `${_vm.idMaster}-scroll-container`,
        `${_vm.idMaster}-scroll-content`
      )}}},[_c('div',{staticClass:"content",style:(_vm.contentStyles),attrs:{"id":`${_vm.idMaster}-scroll-content`}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }